import React, { useEffect, useState, useRef, memo } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import {
  Footer,
  Header,
  TryEdworking,
  EdworkingPromotion,
  TopBanner,
  asPathMap,
} from '../../js/components'
import { FaqsGeneral } from '../tools/[tool]'
import { newLive } from '../../js'
import {
  OrganizationSchema,
  WebPageSchema,
  BreadcrumbListSchema,
  FAQSchema,
} from '../../js/schemas'
import path from 'path'
import fs from 'fs/promises' // or 'fs' if using callbacks
import Link from 'next/link'
import { useRouter } from 'next/router'

export async function getStaticPaths({ locales }) {
  const array = locales.map((locale) => {
    return [
      { locale: 'en', params: { tool: 'writing-hook-generator' } },
      { locale: 'en', params: { tool: 'youtube-channel-description-generator' } },
      { locale: 'en', params: { tool: 'free-hashtag-generator' } },
      { locale: 'en', params: { tool: 'instagram-caption-generator' } },
      { locale: 'en', params: { tool: 'conclusion-generator' } },
      { locale: 'en', params: { tool: 'paragraph-rewriter' } },
      { locale: 'en', params: { tool: 'paraphrasing-tool' } },
      { locale: 'en', params: { tool: 'rewording-tool' } },
      { locale: 'en', params: { tool: 'prompt-generator' } },
      { locale: 'en', params: { tool: 'workout-generator' } },
      { locale: 'en', params: { tool: 'book-summary-generator' } },
      { locale: 'en', params: { tool: 'inspirational-quote-generator' } },
      { locale: 'en', params: { tool: 'magic-spell-name-generator' } },
      { locale: 'en', params: { tool: 'sentence-rewriter' } },
      { locale: 'en', params: { tool: 'keyword-generator' } },
      { locale: 'en', params: { tool: 'emoji-translator' } },
      { locale: 'en', params: { tool: 'blog-title-generator' } },
      { locale: 'en', params: { tool: 'html-code-generator' } },
      { locale: 'en', params: { tool: 'video-script-generator' } },
      { locale: 'en', params: { tool: 'email-responder' } },
      { locale: 'en', params: { tool: 'tweet-generator' } },
      { locale: 'en', params: { tool: 'resume-skills-generator' } },
      { locale: 'en', params: { tool: 'blog-writing-tool' } },

      { locale: 'en', params: { tool: 'product-image-generator' } },
      { locale: 'en', params: { tool: 'marketing-material-generator' } },
      { locale: 'en', params: { tool: 'concept-art-generator' } },
      { locale: 'en', params: { tool: 'character-art-generator' } },
      { locale: 'en', params: { tool: 'illustration-generator' } },
      { locale: 'en', params: { tool: 'instagram-post-generator' } },
      { locale: 'en', params: { tool: 'website-mockup-generator' } },
      { locale: 'en', params: { tool: 'avatar-generator' } },
      { locale: 'en', params: { tool: 'stock-photo-generator' } },
      { locale: 'en', params: { tool: '3d-model-generator' } },

      { locale: 'it', params: { tool: 'generatore-introduzioni' } },
      { locale: 'it', params: { tool: 'generatore-descrizioni-youtube' } },
      { locale: 'it', params: { tool: 'generatore-hashtag' } },
      { locale: 'it', params: { tool: 'generatore-didascalie-instagram' } },
      { locale: 'it', params: { tool: 'generatore-conclusioni' } },
      { locale: 'it', params: { tool: 'riscrittore-paragrafi' } },
      { locale: 'it', params: { tool: 'strumento-parafresi' } },
      { locale: 'it', params: { tool: 'strumento-riformulazione' } },
      { locale: 'it', params: { tool: 'generatore-di-prompt' } },
      { locale: 'it', params: { tool: 'generatore-di-allenamento' } },
      { locale: 'it', params: { tool: 'generatore-di-riassunto-libro' } },
      { locale: 'it', params: { tool: 'generatore-di-citazioni-iscpirative' } },
      { locale: 'it', params: { tool: 'generatore-di-nomi-di-incantesimi-magici' } },
      { locale: 'it', params: { tool: 'rifasatore-di-frasi' } },
      { locale: 'it', params: { tool: 'generatore-di-parole-chiave' } },
      { locale: 'it', params: { tool: 'traduttore-di-emoji' } },
      { locale: 'it', params: { tool: 'generatore-di-titoli-di-blog' } },
      { locale: 'it', params: { tool: 'generatore-di-codice-html' } },
      { locale: 'it', params: { tool: 'generatore-di-script-video' } },
      { locale: 'it', params: { tool: 'risponditore-di-email' } },
      { locale: 'it', params: { tool: 'generatore-di-tweet' } },
      { locale: 'it', params: { tool: 'generatore-di-competenze-per-il-curriculum' } },
      { locale: 'it', params: { tool: 'strumento-di-scrittura-per-blog' } },

      { locale: 'it', params: { tool: 'generatore-immagini-prodotto-ai' } },
      { locale: 'it', params: { tool: 'generatore-materiale-marketing-ai' } },
      { locale: 'it', params: { tool: 'generatore-arte-concettuale-ai' } },
      { locale: 'it', params: { tool: 'generatore-di-personaggi-ai' } },
      { locale: 'it', params: { tool: 'generatore-di-illustrazioni-ai' } },
      { locale: 'it', params: { tool: 'generatore-di-post-per-instagram' } },
      { locale: 'it', params: { tool: 'generatore-di-mockup-per-siti-web' } },
      { locale: 'it', params: { tool: 'generatore-di-avatar' } },
      { locale: 'it', params: { tool: 'generatore-di-foto-stock' } },
      { locale: 'it', params: { tool: 'generatore-di-modelli-3d' } },

      { locale: 'es', params: { tool: 'generador-ganchos' } },
      { locale: 'es', params: { tool: 'generador-descripciones-youtube' } },
      { locale: 'es', params: { tool: 'generador-hashtags' } },
      { locale: 'es', params: { tool: 'generador-textos-instagram' } },
      { locale: 'es', params: { tool: 'generador-conclusiones' } },
      { locale: 'es', params: { tool: 'reescritor-parrafos' } },
      { locale: 'es', params: { tool: 'herramienta-parafrasis' } },
      { locale: 'es', params: { tool: 'herramienta-reformulacion' } },
      { locale: 'es', params: { tool: 'generador-de-prompt' } },
      { locale: 'es', params: { tool: 'generador-de-entrenamientos' } },
      { locale: 'es', params: { tool: 'generador-de-resumenes-de-libros' } },
      { locale: 'es', params: { tool: 'generador-de-citas-inspiradoras' } },
      { locale: 'es', params: { tool: 'generador-de-nombres-de-hechizos' } },
      { locale: 'es', params: { tool: 'reescritor-de-frases' } },
      { locale: 'es', params: { tool: 'generador-de-palabras-clave' } },
      { locale: 'es', params: { tool: 'traductor-de-emojis' } },
      { locale: 'es', params: { tool: 'generador-de-titulos-de-blog' } },
      { locale: 'es', params: { tool: 'generador-de-codigo-html' } },
      { locale: 'es', params: { tool: 'generador-de-guiones-de-video' } },
      { locale: 'es', params: { tool: 'respondedor-de-correo-electronico' } },
      { locale: 'es', params: { tool: 'generador-de-tweets' } },
      { locale: 'es', params: { tool: 'generador-de-habilidades-para-el-curriculum' } },
      { locale: 'es', params: { tool: 'generador-de-contenido-para-blogs' } },

      { locale: 'es', params: { tool: 'generador-de-imagenes-de-producto' } },
      { locale: 'es', params: { tool: 'generador-de-material-de-marketing' } },
      { locale: 'es', params: { tool: 'generador-de-arte-conceptual' } },
      { locale: 'es', params: { tool: 'generador-de-arte-de-personajes' } },
      { locale: 'es', params: { tool: 'generador-de-ilustraciones' } },
      { locale: 'es', params: { tool: 'generador-de-publicaciones-de-instagram' } },
      { locale: 'es', params: { tool: 'generador-de-mockups-de-sitios-web' } },
      { locale: 'es', params: { tool: 'generador-de-avatar' } },
      { locale: 'es', params: { tool: 'generador-de-fotos-de-stock' } },
      { locale: 'es', params: { tool: 'generador-de-modelos-3d' } },

      { locale: 'fr', params: { tool: 'generateur-crochet' } },
      { locale: 'fr', params: { tool: 'generateur-description-youtube' } },
      { locale: 'fr', params: { tool: 'generateur-hashtags' } },
      { locale: 'fr', params: { tool: 'generateur-legendes-instagram' } },
      { locale: 'fr', params: { tool: 'generateur-conclusion' } },
      { locale: 'fr', params: { tool: 'reecriveur-paragraphes' } },
      { locale: 'fr', params: { tool: 'outil-paraphrase' } },
      { locale: 'fr', params: { tool: 'outil-reformulation' } },
      { locale: 'fr', params: { tool: 'generateur-de-prompts' } },
      { locale: 'fr', params: { tool: 'generateur-dentrainement' } },
      { locale: 'fr', params: { tool: 'generateur-de-resume-de-livre' } },
      { locale: 'fr', params: { tool: 'generateur-de-citations-inspirantes' } },
      { locale: 'fr', params: { tool: 'generateur-de-noms-de-sortileges' } },
      { locale: 'fr', params: { tool: 'rephraseur-de-phrases' } },
      { locale: 'fr', params: { tool: 'generateur-de-mots-cles' } },
      { locale: 'fr', params: { tool: 'traducteur-d-emoji' } },
      { locale: 'fr', params: { tool: 'generateur-de-titres-de-blog' } },
      { locale: 'fr', params: { tool: 'generateur-de-code-html' } },
      { locale: 'fr', params: { tool: 'generateur-de-script-video' } },
      { locale: 'fr', params: { tool: 'repondeur-email' } },
      { locale: 'fr', params: { tool: 'generateur-de-tweets' } },
      { locale: 'fr', params: { tool: 'generateur-de-competences-pour-cv' } },
      { locale: 'fr', params: { tool: 'outil-redaction-blog' } },

      { locale: 'fr', params: { tool: 'generateur-image-produit' } },
      { locale: 'fr', params: { tool: 'generateur-materiel-marketing' } },
      { locale: 'fr', params: { tool: 'generateur-art-conceptuel' } },
      { locale: 'fr', params: { tool: 'generateur-dart-de-personnage' } },
      { locale: 'fr', params: { tool: 'generateur-dillustration-ai' } },
      { locale: 'fr', params: { tool: 'generateur-de-publications-instagram-ai' } },
      { locale: 'fr', params: { tool: 'generateur-de-maquettes-de-sites-web-ai' } },
      { locale: 'fr', params: { tool: 'generateur-davatar-ai' } },
      { locale: 'fr', params: { tool: 'generateur-de-photos-libres-de-droits-ai' } },
      { locale: 'fr', params: { tool: 'generateur-de-modeles-3d-ai' } },

      { locale: 'de', params: { tool: 'haken-generator' } },
      { locale: 'de', params: { tool: 'youtube-kanalbeschreibungsgenerator' } },
      { locale: 'de', params: { tool: 'hashtag-generator' } },
      { locale: 'de', params: { tool: 'instagram-untertitel-generator' } },
      { locale: 'de', params: { tool: 'schlussfolgerungs-generator' } },
      { locale: 'de', params: { tool: 'absatz-umformulierer' } },
      { locale: 'de', params: { tool: 'umformulierungs-werkzeug' } },
      { locale: 'de', params: { tool: 'umschreibungs-tool' } },
      { locale: 'de', params: { tool: 'prompt-generator' } },
      { locale: 'de', params: { tool: 'workout-generator' } },
      { locale: 'de', params: { tool: 'buchzusammenfassungs-generator' } },
      { locale: 'de', params: { tool: 'inspirationszitat-generator' } },
      { locale: 'de', params: { tool: 'zauberspruch-namensgenerator' } },
      { locale: 'de', params: { tool: 'satz-umformulierer' } },
      { locale: 'de', params: { tool: 'schluesselwort-generator' } },
      { locale: 'de', params: { tool: 'emoji-uebersetzer' } },
      { locale: 'de', params: { tool: 'blog-titel-generator' } },
      { locale: 'de', params: { tool: 'html-code-generator' } },
      { locale: 'de', params: { tool: 'video-skript-generator' } },
      { locale: 'de', params: { tool: 'email-antwort-generator' } },
      { locale: 'de', params: { tool: 'tweet-generator' } },
      { locale: 'de', params: { tool: 'lebenslauf-fahigkeiten-generator' } },
      { locale: 'de', params: { tool: 'blog-schreibwerkzeug' } },

      { locale: 'de', params: { tool: 'produktbild-generator' } },
      { locale: 'de', params: { tool: 'marketingmaterial-generator' } },
      { locale: 'de', params: { tool: 'konzeptkunst-generator' } },
      { locale: 'de', params: { tool: 'charakterkunst-generator' } },
      { locale: 'de', params: { tool: 'illustrationsgenerator' } },
      { locale: 'de', params: { tool: 'instagram-post-generator' } },
      { locale: 'de', params: { tool: 'website-mockup-generator' } },
      { locale: 'de', params: { tool: 'avatar-generator' } },
      { locale: 'de', params: { tool: 'stock-photo-generator' } },
      { locale: 'de', params: { tool: '3d-modell-generator' } },

      { locale: 'pt', params: { tool: 'gerador-gancho' } },
      { locale: 'pt', params: { tool: 'gerador-descriçao-youtube' } },
      { locale: 'pt', params: { tool: 'gerador-hashtags' } },
      { locale: 'pt', params: { tool: 'gerador-legendas-instagram' } },
      { locale: 'pt', params: { tool: 'gerador-conclusao' } },
      { locale: 'pt', params: { tool: 'reescritor-paragrafos' } },
      { locale: 'pt', params: { tool: 'ferramenta-parafrase' } },
      { locale: 'pt', params: { tool: 'ferramenta-reformulaçao' } },
      { locale: 'pt', params: { tool: 'gerador-de-prompts' } },
      { locale: 'pt', params: { tool: 'gerador-de-treino' } },
      { locale: 'pt', params: { tool: 'gerador-de-resumo-de-livros' } },
      { locale: 'pt', params: { tool: 'gerador-de-frases-inspiradoras' } },
      { locale: 'pt', params: { tool: 'gerador-de-nome-de-encantamento-magico' } },
      { locale: 'pt', params: { tool: 'reescritor-de-frases' } },
      { locale: 'pt', params: { tool: 'gerador-de-palavras-chave' } },
      { locale: 'pt', params: { tool: 'tradutor-de-emojis' } },
      { locale: 'pt', params: { tool: 'gerador-de-titulo-de-blog' } },
      { locale: 'pt', params: { tool: 'gerador-de-codigo-html' } },
      { locale: 'pt', params: { tool: 'gerador-de-roteiro-de-video' } },
      { locale: 'pt', params: { tool: 'resposta-de-email' } },
      { locale: 'pt', params: { tool: 'gerador-de-tweets' } },
      { locale: 'pt', params: { tool: 'gerador-de-habilidades-para-curriculo' } },
      { locale: 'pt', params: { tool: 'ferramenta-de-escrita-de-blog' } },

      { locale: 'pt', params: { tool: 'gerador-de-imagens-de-produto' } },
      { locale: 'pt', params: { tool: 'gerador-de-material-de-marketing' } },
      { locale: 'pt', params: { tool: 'gerador-de-arte-de-conceito' } },
      { locale: 'pt', params: { tool: 'gerador-de-arte-de-personagem' } },
      { locale: 'pt', params: { tool: 'gerador-de-ilustracao' } },
      { locale: 'pt', params: { tool: 'gerador-de-post-do-instagram' } },
      { locale: 'pt', params: { tool: 'gerador-de-mockup-de-site' } },
      { locale: 'pt', params: { tool: 'gerador-de-avatar' } },
      { locale: 'pt', params: { tool: 'gerador-de-foto-de-estoque' } },
      { locale: 'pt', params: { tool: 'gerador-de-modelo-3d' } },
    ]
  })
  return {
    paths: array.flat(1),
    fallback: false,
  }
}

export async function getStaticProps({ locale, locales, params }) {
  let content
  try {
    const filePath = path.join(process.cwd(), 'public', 'content', locale, 'aitools.json')

    const jsonData = await fs.readFile(filePath, 'utf8')
    content = JSON.parse(jsonData)
  } catch (error) {
    console.error('error', error)
  }
  return {
    props: { content, locale, locales, tool: params.tool },
  }
}

export default function Aitools({ content, locale, locales, tool }) {
  const [promotion, setPromotion] = useState(false)
  const toolContent = content.tools.find((t) => t.name === tool)

  const onMouseOut = () => {
    const goon = localStorage.getItem('promotion')
    if (!goon) setPromotion(true)
    document.body.removeEventListener('mouseleave', onMouseOut)
  }

  useEffect(() => {
    setTimeout(function () {
      document.body.addEventListener('mouseleave', onMouseOut)
    }, 3000)
  }, [])

  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'UA-166939348-2');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NRW96HD');
        `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2080824,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <OrganizationSchema />
      <WebPageSchema name={toolContent.title} description={toolContent.description} />
      <BreadcrumbListSchema
        items={[
          {
            name: 'Home',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}`,
          },
          {
            name: 'AI Tools',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}ai-tools`,
          },
          {
            name: toolContent.title,
            url: `https://edworking.com/${
              locale !== 'en' ? `${locale}/` : ''
            }ai-tools/${tool}`,
          },
        ]}
      />
      <FAQSchema faqs={toolContent.faqs.content} />
      <Head>
        <title>{toolContent.title}</title>
        <meta itemProp="name" content={toolContent.metaTitle} />
        <meta itemProp="description" content={toolContent.description} />
        <meta name="description" content={toolContent.description} />
        <link rel="shortcut icon" href="/images/favicon.ico" />
        <meta itemProp="image" content={'/images/TaskAutomation.png'} />
        <meta
          property="og:url"
          content={`https://edworking.com${locale !== 'en' ? `/${locale}` : ''}${asPathMap(
            `/ai-tools/${tool}`,
            locale
          )}`}
        />
        <meta property="og:locale" content="en_GB" />
        <meta property="og:image:secure_url" content={'/images/TaskAutomation.png'} />
        {locales.map((locale1, index) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={locale1}
            href={`https://edworking.com${locale1 !== 'en' ? `/${locale1}` : ''}${asPathMap(
              `/ai-tools/${tool}`,
              locale1
            )}`}
          />
        ))}
        <link
          rel="alternate"
          href={`https://edworking.com${asPathMap(`/ai-tools/${tool}`, 'en')}`}
          hrefLang="x-default"
        />
        <link
          rel="canonical"
          href={`https://edworking.com${locale !== 'en' ? `/${locale}` : ''}${asPathMap(
            `/ai-tools/${tool}`,
            locale
          )}`}
          key="canonical"
        />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <EdworkingPromotion promotion={promotion} content={content.promotion} />
      {/*<TopBanner content={content.topbanner} />*/}
      <Header content={content.header} topbanner={true} />
      <Information content={toolContent} available={content.available} />
      {toolContent.type === 'image' ? (
        <ToolImage locale={locale} content={toolContent} tool={tool} />
      ) : (
        <Tool locale={locale} content={toolContent} tool={tool} />
      )}
      <SimilarTools tools={content.tools} title={content.similar} all={content.seeall} />
      <FaqsGeneral content={toolContent.faqs.content} head={toolContent.faqs.head} />
      <TryEdworking content={content.endbanner} />
      <Footer content={content.footer} />
      <div id="livenoti" className="livenoti"></div>
    </>
  )
}
const server = process.env.NEXT_PUBLIC_VENUSAUR
export const fetchAI = async (body) => {
  return fetch(`${server}api/ai-request-public`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
}
export const fetchAIImage = async (body) => {
  return fetch(`${server}api/ai-request-public-image`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then((response) => {
      if (!response.ok) {
        if (response.status === 429) {
          newLive(
            '/images/Logo.svg',
            'Rate Limit reached ',
            ' Signup for exclusive use of our features'
          )
          return
        } else throw new Error(`Network response was not ok, status: ${response.status}`)
      }
      // Only attempt to parse as JSON if the response is not empty
      return response.text().then((text) => {
        return text ? JSON.parse(text) : {}
      })
    })
    .catch((error) => {
      // Handle fetch errors or errors thrown from parsing
      console.error('Fetch error:', error)
      throw error // Re-throw the error for further handling if necessary
    })
}
export function extractValues(data) {
  const contents = []
  // Updated regex to match the pattern `data: "value"`
  const regex = /data: "([^"]+)"/g
  let match

  while ((match = regex.exec(data)) !== null) {
    contents.push(match[1])
  }

  return { contents }
}
const ToolImage = ({ content, tool, locale }) => {
  const [loading, setLoading] = useState(false)
  const [text, setText] = useState('')
  const [image, setImage] = useState()
  const resultsRef = useRef(null)

  const requestAI = async () => {
    if (text === '') return
    setLoading(true)
    setImage()
    const response = await fetchAIImage({
      description: text,
      type: tool,
      language: locale,
    })
    setImage(response?.image_url)
    setLoading(false)
  }
  return (
    <section className="ai-tool image">
      <textarea
        id="textArea"
        ref={resultsRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="textInput"
        placeholder={content.placeholder}
      ></textarea>
      {(loading || image !== '') && (
        <div
          className="results"
          style={{
            background: `url(${!image ? '/images/ai/loading.png' : image}) center / contain`,
          }}
        >
          <div
            className="loading"
            style={{ opacity: loading ? 1 : 0, fontSize: 18, fontWeight: 600 }}
          >
            Generating Image...
          </div>
          {!image ? (
            <div
              className="blueButton"
              style={{ opacity: loading ? 0.5 : 1 }}
              onClick={() => !loading && requestAI()}
            >
              {content.submit}
            </div>
          ) : (
            <a
              href={image}
              target="_blank noopener noreferrer"
              download="edworking_ai_image.webp"
              className="blueButton"
              onClick={() => newLive('/images/CopyLink.svg', 'Image', ' downloaded')}
            >
              Download
            </a>
          )}
        </div>
      )}
    </section>
  )
}

const Tool = ({ content, tool, locale }) => {
  const [loading, setLoading] = useState(false)
  const [text, setText] = useState('')
  const [data, setData] = useState('')
  const resultsRef = useRef(null)

  const requestAI = async () => {
    if (text === '') return
    setLoading(true)
    setData('')
    const response = await fetchAI({
      description: text,
      type: tool,
      language: locale,
    })
    if (!response) {
      console.error('Invalid Parameters')
      return
    }
    if (!response.ok) {
      console.error('Network response was not ok')
      return
    }
    if (!response.body || typeof response.body.getReader !== 'function') {
      console.error('Invalid response format')
      return
    }
    const reader = response.body.getReader()
    const readChunk = async () => {
      const { done, value } = await reader.read()
      if (value) {
        // Decode the current chunk
        const newChunk = new TextDecoder().decode(value)
        const { contents } = extractValues(newChunk)
        // Update the data with the contents of the current chunk
        setLoading(false)
        setData((prev) => prev + contents.join('')) //.map((c) => c.replace(/\\/g, ' ')).join(''))
      }
      if (done) {
        return
      }
      readChunk()
    }

    // All data has been read
    const elementPosition = resultsRef.current.getBoundingClientRect().top + window.pageYOffset
    const desiredPosition = elementPosition - 135

    window.scrollTo({
      top: desiredPosition,
      behavior: 'smooth',
    })

    readChunk()
    return
  }

  const copyToClipboard = (str) => {
    const el = document.createElement('textarea')
    el.value = str
    document.body.appendChild(el)
    el.select()
    newLive('/images/CopyLink.svg', 'Text', ' copied')
    document.execCommand('copy')
    document.body.removeChild(el)
  }
  return (
    <section className="ai-tool">
      <textarea
        id="textArea"
        ref={resultsRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        className="textInput"
        placeholder={content.placeholder}
      ></textarea>
      <div type="button" className="blueButton" onClick={() => requestAI()}>
        {content.submit}
      </div>
      {(loading || data !== '') && (
        <div className="results">
          <div className="text">
            {loading
              ? 'Loading Results...'
              : data.split('\\n').map((line, index, array) => (
                  <React.Fragment key={index}>
                    {line}
                    {index < array.length - 1 && <br />}
                  </React.Fragment>
                ))}
          </div>
          <div className="blueButton" onClick={() => copyToClipboard(data)}>
            Copy
          </div>
        </div>
      )}
    </section>
  )
}
function mapLanguage(languageWord, languageToTranslate) {
  // Dictionary of languages with their names in different languages
  const languages = {
    en: {
      en: 'English',
      es: 'Inglés',
      it: 'Inglese',
      de: 'Englisch',
      pt: 'Inglês',
      fr: 'Anglais',
    },
    es: {
      en: 'Spanish',
      es: 'Español',
      it: 'Spagnolo',
      de: 'Spanisch',
      pt: 'Espanhol',
      fr: 'Espagnol',
    },
    it: {
      en: 'Italian',
      es: 'Italiano',
      it: 'Italiano',
      de: 'Italienisch',
      pt: 'Italiano',
      fr: 'Italien',
    },
    de: {
      en: 'German',
      es: 'Alemán',
      it: 'Tedesco',
      de: 'Deutsch',
      pt: 'Alemão',
      fr: 'Allemand',
    },
    pt: {
      en: 'Portuguese',
      es: 'Portugués',
      it: 'Portoghese',
      de: 'Portugiesisch',
      pt: 'Português',
      fr: 'Portugais',
    },
    fr: {
      en: 'French',
      es: 'Francés',
      it: 'Francese',
      de: 'Französisch',
      pt: 'Francês',
      fr: 'Français',
    },
  }

  return languages[languageWord]?.[languageToTranslate] || ''
}

const Information = ({ content, available }) => {
  const { asPath, locales, locale } = useRouter()

  return (
    <section className="aptitude-test">
      <h1>{content.titleh1}</h1>
      <div className="description">
        {content.introtext} {available}
        {locales.map((locale1, index) => (
          <>
            <Link
              key={index}
              href={asPathMap(`/ai-tools/${content.name}`, locale1)}
              locale={locale1}
              className="more"
            >
              {mapLanguage(locale1, locale)}
            </Link>
            {index < 4 ? <span>, </span> : index === 4 ? <span> and </span> : null}
          </>
        ))}
      </div>
    </section>
  )
}
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]] // Swap elements
  }
}

export const SimilarTools = memo(({ tools, title, all }) => {
  const [selectedTools, setSelectedTools] = useState([])
  useEffect(() => {
    shuffleArray(tools) // Shuffle the array on the client-side
    setSelectedTools(tools.slice(0, 4)) // Set the first four elements
  }, [tools]) // Empty dependency array ensures this runs once on mount

  return (
    <section className="similararticles nobanner" style={{ marginTop: 100 }}>
      <div className="sectiontop">
        <h2 className="title">{title}</h2>
        <Link href={'/ai-tools'} className="more">
          {all}
        </Link>
      </div>
      <div className="articles" style={{ width: '100%', margin: '55px 0 80px 0' }}>
        {selectedTools.map((tool, index) => {
          return (
            <Link key={index} className="single" href={`/ai-tools/${tool.name}`}>
              <span className="title">{tool.title}</span>
              <span className="resume">{tool.description}</span>
              <div className="subtitle">
                <span className="author">
                  <span>{tool.type}</span>
                </span>
              </div>
            </Link>
          )
        })}
      </div>
      <Script
        type="text/javascript"
        id="hs-script-loader"
        async
        defer
        src="//js-eu1.hs-scripts.com/25992597.js"
      ></Script>
    </section>
  )
})
